import Vue from 'vue'
import permissionsMixin from './permissionsMixin'
import permissionsDirective from './permissionsDirective'

Vue.mixin(permissionsMixin)

Vue.directive('can', permissionsDirective)
